import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';
  const isTransparent = isHome && !scrolled && !mobileOpen;

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-xl font-heading font-bold whitespace-nowrap transition-colors ${
              isTransparent ? 'text-white' : 'text-foreground-950'
            }`}
          >
            <h1 className="text-xl font-heading font-bold inline">17c.cn</h1>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? isTransparent
                    ? 'text-white bg-white/20'
                    : 'text-primary-700 bg-primary-100'
                  : isTransparent
                    ? 'text-white/80 hover:text-white hover:bg-white/10'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? isTransparent
                      ? 'text-white bg-white/20'
                      : 'text-primary-700 bg-primary-100'
                    : isTransparent
                      ? 'text-white/80 hover:text-white hover:bg-white/10'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? isTransparent
                    ? 'text-white bg-white/20'
                    : 'text-primary-700 bg-primary-100'
                  : isTransparent
                    ? 'text-white/80 hover:text-white hover:bg-white/10'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-5 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
                isTransparent
                  ? 'bg-white/20 text-white hover:bg-white/30 border border-white/30'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              立即访问
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isTransparent ? 'text-white hover:bg-white/10' : 'text-foreground-700 hover:bg-background-200'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-700 bg-primary-100'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors text-left cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-700 bg-primary-100'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-700 bg-primary-100'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
            <Link
              to="/about"
              className="mt-2 px-5 py-3 text-sm font-medium rounded-full text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              立即访问
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}